import { css, CSSObject, SimpleInterpolation, FlattenInterpolation, ThemeProps, DefaultTheme } from 'styled-components';

export interface IColors {
  deepBlueColor: string;
  wheelButt: string;
  wheelButtDark: string;
  red: string;
  blue: string;
  gray700: string;
  blue100: string;
  blue200: string;
}

export interface IFlexGrid {
  gutterWidth: number;
  outerMargin: number;
  mediaQuery: string;
  container: Record<string, number>;
  breakpoints: Record<TBreakpoints, number>;
}

const colors = {
  deepBlueColor: '#29304D',
  wheelButt: '#323E5C',
  wheelButtDark: '#20293e',
  red: '#d83f3f',
  blue: '#259DF8',
  gray700: '#d8d8d8',
  blue100: '#4d5f8e',
  blue200: '#0049B5',
  green: '#1ac571',
};

const theme = {
  colors,
  backgroundColor: colors.deepBlueColor,
  comonentColor: 'white',
  componentDarkColor: colors.wheelButt,
  comonentColorGray: colors.gray700,
  textBaseColor: 'black',
  textInvertedColor: 'white',
  errorColor: colors.red,
  successColor: colors.green,
  primaryColor: colors.blue,
  textSecondaryColor: 'rgba(255, 255, 255, 0.7)',
  textShadowedColor: '#858A8F',
  boxShadowColor: colors.blue200,
  drawerWidth: '80vw',

  fontFamily: `Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
         "Helvetica Neue", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
         SimSun, sans-serif`,

  borderRadius: '3px',
  transitionDuration: '200ms',
  transitionFunction: 'ease-in-out',

  flexboxgrid: {
    gutterWidth: 0, // rem
    outerMargin: 1, // rem
    mediaQuery: 'only screen',
    container: {
      sm: 46, // rem
      md: 56, // rem
      lg: 70, // rem
    },
    breakpoints: {
      xs: 0, // em
      sm: 48, // em
      md: 60, // em
      lg: 80, // em
    },
  },
};
export type TBreakpoints = 'xs' | 'sm' | 'md' | 'lg';
type TMediaFunction = (
  first: TemplateStringsArray | CSSObject,
  ...interpolations: Array<SimpleInterpolation | FlattenInterpolation<ThemeProps<DefaultTheme>>>
) => FlattenInterpolation<ThemeProps<DefaultTheme>>;
type TMedias = Record<TBreakpoints, TMediaFunction>;
const media: TMedias = Object.keys(theme.flexboxgrid.breakpoints).reduce((acc, label) => {
  acc[label as TBreakpoints] = (...args) => css`
    @media (min-width: ${theme.flexboxgrid.breakpoints[label]}rem) {
      ${css(...args)}
    }
  `;
  return acc;
}, {} as TMedias);

export { media, theme };

export default theme;
